import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { AppLink } from 'lib/app/app-link';
import { CdnImagePath } from 'lib/cdn-image-path';
import LocaleContext from 'lib/locale-context';

import { onClickAboutCTA } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';
import { P1 } from 'components/typography';

export const SuperswipeBlockTwoContainer: FunctionComponent = () => {
    const lang = React.useContext(LocaleContext);

    const imagePath = `${CdnImagePath}/bumble/l-assets/${lang}/features/Superswipe-HowtouseSuperSwipe.jpg`;
    const props = {
        imagePosition: 'left',
        imageSrc: imagePath,
        imageObjectPosition: '33% 31%',
        imageAlt: '',
        title: features.superswipe.lxSuperswipeTwoBlockTitle,
        text: features.superswipe.lxSuperswipeTwoBlockBodyText,
        actionText: features.superswipe.lxFeaturesTryItNowCta,
        actionUrl: AppLink.BUMBLE_GET_STARTED,
    };

    return (
        <PageSectionCta
            title={props.title}
            /**
             * Fix language based code
             */
            // titleLang={'en'}
            text={<P1 html={props.text}></P1>}
            action={{
                text: props.actionText,
                href: props.actionUrl,
                onClick: onClickAboutCTA,
            }}
            image={{
                src: props.imageSrc,
                objectPosition: props.imageObjectPosition,
                inlinePosition: 'start',
            }}
            color="yellow"
        />
    );
};
